const s = {
  name: "Safe",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,20c0-6.1,4.9-11,11-11s11,4.9,11,11c0,6.1-4.9,11-11,11S9,26.1,9,20z M11,20c0,1.3,0.3,2.5,0.8,3.6
			l4.4-2.5C16.1,20.7,16,20.4,16,20c0-1.9,1.3-3.4,3-3.9v-5.1C14.5,11.6,11,15.4,11,20z M12.8,25.3C14.4,27.6,17,29,20,29
			s5.6-1.4,7.2-3.7l-4.4-2.5C22.1,23.5,21.1,24,20,24s-2.1-0.5-2.9-1.2L12.8,25.3z M29,20c0-4.6-3.5-8.4-8-8.9v5.1
			c1.7,0.4,3,2,3,3.9c0,0.4-0.1,0.7-0.1,1.1l4.4,2.5C28.7,22.5,29,21.3,29,20z M18,20c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2
			c0-1.1-0.9-2-2-2C18.9,18,18,18.9,18,20z"/>
		<path class="st0" d="M35,5H5v30h30V5z M7,33V7h26v26H7z"/>
		<path class="st0" d="M0,5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v30c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5z M5,2C3.3,2,2,3.3,2,5v30
			c0,1.7,1.3,3,3,3h30c1.7,0,3-1.3,3-3V5c0-1.7-1.3-3-3-3H5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Safe
};
